import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icon/chevron-left" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M15.5 18L9.5 12L15.5 6", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgChevronLeft);
export { ForwardRef as ReactComponent };
